import AppServiceNewApi from "./AppServiceNewApi";

class TicketService extends AppServiceNewApi{
    constructor(){
        super();
        this.path = '/api/internal/v1/tickets';
    }

    getTickets(params){
        let filterString = '&'
        if(params?.filters?.status)filterString = `${filterString}Status=${encodeURIComponent(params.filters?.status)}&`
        if(params?.filters?.createdAt)filterString = `${filterString}CreatedAt=${encodeURIComponent(params.filters?.createdAt)}&`
        if(params?.filters?.updatedAt)filterString = `${filterString}UpdatedAt=${encodeURIComponent(params.filters?.updatedAt)}&`
        if(params?.sort?.sortBy)filterString = `${filterString}SortBy=${params?.sort.sortBy}&SortDescending=${params?.sort?.sortDescending}&`
        if(filterString === '&')filterString = ''
        else filterString = filterString.substring(0, filterString?.length - 1)
        return this.http.get(`${this.path}?PageNumber=${params?.pagination?.page}&PageSize=${params?.pagination?.size}${filterString}`);
    }
    
    getTicketDetail(id){
        return this.http.get(`${this.path}/${id}`);
    }

    updateStatus(id, status){
        return this.http.patch(`${this.path}/${id}?status=${status}`);
    }

    saveTicket(ticket){
        return this.http.post(`${this.path}`, ticket);
    }
    
    editTicket(id, ticket){
        return this.http.put(`${this.path}/${id}`, ticket);
    }

    saveImageByTicket(ticketId, file){
        return this.http.post(`${this.path}/${ticketId}`, file);
    }

    updateResponseDev(id, response){
        return this.http.patch(`${this.path}/dev-response/${id}`, response);
    }
}

export default TicketService;